import { Box, HStack, Icon, SimpleGrid } from '@chakra-ui/core';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { MdInfoOutline } from 'react-icons/md';
import { InfoHint } from '../../../common/Tooltip/Tooltip';
import { SectionLabel } from '../SectionLabel';
import { VideoEffectStore } from '../store/videoEffectModel';
import { BackgroundImage } from '../videoEffectTypes';
import { AddCustomBackground } from './AddCustomBackground';
import { VideoBackgroundCard } from './VideoBackgroundCard';

interface VideoCustomBackgroundProps {
  onBackgroundSelect: (background: BackgroundImage | null) => void;
}

export const VideoCustomBackground = memo(function VideoCustomBackground({ onBackgroundSelect }: VideoCustomBackgroundProps) {
  const { t } = useTranslation('videoInterviewEffect');
  const preferences = VideoEffectStore.useStoreState((state) => state.preferences);
  const selectedBackground = VideoEffectStore.useStoreState((state) => state.activeBackgroundId);

  const uploadedImages = preferences?.participantPreference?.uploadedImages;
  const showAddCustomBackground = !uploadedImages || uploadedImages.length < 3;
  return (
    <Box flexShrink={0} mb={4}>
      <HStack justifyContent="space-between" width="100%">
        <SectionLabel>{t('customBackgroundEffects.title')}</SectionLabel>
        <InfoHint label={t('customBackgroundEffects.info')} width={250} placement="left">
          <Icon name="info" color="gray.500" size="sm" as={MdInfoOutline} />
        </InfoHint>
      </HStack>
      <SimpleGrid spacing={2} columns={3}>
        {showAddCustomBackground && <AddCustomBackground />}
        {uploadedImages?.map((bg) => (
          <VideoBackgroundCard
            image={bg}
            isActive={selectedBackground === bg.id}
            onClick={() => onBackgroundSelect(selectedBackground === bg.id ? null : bg)}
            isApplying={false}
            isLoading={false}
            key={bg.id}
          />
        ))}
      </SimpleGrid>
    </Box>
  );
});
